import { Column } from "@coreui/react-pro/dist/components/smart-table/types";

export const getAssigneeDetailsTableColumnsAdapter = (
  theme: string,
  media: {
    min: {
      xs: boolean;
      sm: boolean;
      md: boolean;
      lg: boolean;
      xl: boolean;
      xxl: boolean;
    };
    max: {
      xs: boolean;
      sm: boolean;
      md: boolean;
      lg: boolean;
      xl: boolean;
      xxl: boolean;
    };
  },
): Column[] => {
  const headerStyle =
    theme === "light"
      ? { backgroundColor: "#2D3569", color: "white" }
      : { backgroundColor: "#282933", color: "white" };

  return [
    {
      key: "id",
      label: "#",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
        className: "text-center",
      },
    },
    {
      key: "name",
      label: "Name",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
      },
    },
    {
      key: "department",
      label: "Department",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
        hidden: media.max.lg,
      },
    },
    {
      key: "position",
      label: " Position",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
        hidden: media.max.lg,
      },
    },
    {
      key: "contactNo",
      label: "Contact No.",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
        hidden: media.max.lg,
      },
    },
    {
      key: "email",
      label: "Email",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
      },
    },
    {
      key: "actions",
      label: "Action",
      _style: { ...headerStyle, textAlign: "center", verticalAlign: "middle" },
      _props: {
        color: "primary",
      },
    },
  ];
};
